var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-400 font-serif"},[_c('HeaderNav'),_c('ContentBox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }